/* Extern */
import React, { Component } from 'react';
import Image from 'next/image';

/* Intern */
import { asset } from '../lib/Util';

class TopMenu extends Component {
  render() {
    return (
      <div className="top-menu">
        <div className="icon">
          <Image className="image" src={asset('classapp-compact-logo.svg')} alt="classapp logo" height="60px" width="100%" unoptimized />
        </div>
      </div>
    );
  }
}

export default TopMenu;
